"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var icons_1 = require("../../../icons");
var Input_1 = __importDefault(require("../Input"));
var styles_1 = require("./styles");
var CustomInput = react_2.forwardRef(function (_a, ref) {
    var value = _a.value, onClick = _a.onClick, range = _a.range, _b = _a.placeholder, placeholder = _b === void 0 ? range ? 'Select dates' : 'Select date' : _b, props = __rest(_a, ["value", "onClick", "range", "placeholder"]);
    return (react_1.jsx(Input_1.default, __assign({ before: react_1.jsx(icons_1.Calendar, null), placeholder: placeholder, value: value, ref: ref, inputProps: { onClick: onClick, style: { caretColor: 'transparent' } }, css: styles_1.style.customInput(range) }, props)));
});
exports.default = CustomInput;
